import React from 'react';
import LoadingPage from '../../reusableComponents/loader/loadingPage';
import NoDataFound from '../../utilsComponent/noDataFound';
import DocumentSliderModal from '../../utilsComponent/DocumentSliderModal';
import "../documentsIAGRI/PolicyDocumentsSection.scss" 

const PolicyDocumentsSection = ({
    documents,
    isLoadingDocuments,
    openDocumentSlider,
    isSliderOpen,
    currentSlideIndex,
    setCurrentSlideIndex,
    onSliderClose
}) => {
    return (
        <>
            <div className='policy-documents-section'>
                {isLoadingDocuments ? (
                    <LoadingPage />
                ) : documents.length > 0 ? (
                    <div className='documents-table-container'>
                        <table className='documents-table'>
                            <thead>
                                <tr>
                                    <th>S.No</th>
                                    <th>Type</th>
                                    <th>Document Link</th>
                                </tr>
                            </thead>
                            <tbody>
                                {documents.map((doc, index) => (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{doc.type}</td>
                                        <td
                                            onClick={() => openDocumentSlider(index)}
                                            className='document-link text-primary'
                                        >
                                            {doc.name || "View Document"}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                ) : (
                    <NoDataFound text="No Policy Document Found." />
                )}
            </div>

            {isSliderOpen && (
                <DocumentSliderModal
                    currentIndex={currentSlideIndex}
                    setCurrentIndex={setCurrentSlideIndex}
                    onClose={onSliderClose}
                    documents={documents}
                    show={isSliderOpen}
                />
            )}
        </>
    );
};

export default PolicyDocumentsSection;
